import React, { useCallback, useMemo, useState } from 'react';
import Chart from './Chart';
import Category from '../../models/Category';
import getCategoryGroupsByType from '../../utilities/getCategoryGroupsByType';
import { moneyFormatFromCents } from "../../utilities/moneyFormat";
import SummaryCategoryItem from "./summary/SummaryCategoryItem";
import SummaryCategoryItems from "./summary/SummaryCategoryItems";
import NoResults from "../elements/NoResults.jsx";

export default function SummaryPieChart(props) {
	const { selectedDates, categoryGroups, categories } = props;
	const [highlightedCategoryIndex, updateHighlightedCategoryIndex] = useState(null);

	const categoryMouseEnter = useCallback((category) => {
		const index = categoryIndexes.get(category);
		if(index === undefined) {
			console.error('invalid index for category', category, index);
		}
		updateHighlightedCategoryIndex(index);
	}, [categories, selectedDates]);

	const categoryMouseLeave = useCallback((category) => {
		updateHighlightedCategoryIndex(null);
	}, [categories, selectedDates]);

	const { foundData, graphData, categoriesToDisplay, categoriesByIndex, categoryIndexes } = useMemo(() => {
		const groups = getCategoryGroupsByType(Category.types.EXPENSE);
		const graphData = {
			label: 'Test',
			datasets: [{
				data: [],
				backgroundColor: [],
				borderColors: []
			}],
			options: {
				legend: {
					display: false,
				}
			},
			labels: [],

		};

		const dataset = graphData.datasets[0];
		let foundData = false;

		const categoriesToDisplay = [];
		const categoriesByIndex = {};
		const categoryIndexes = new Map();
		let currentIndex = 0;
		dataset.hoverBackgroundColor = [];
		groups.forEach((group) => {
			const groupCategories = group.getCategories();
			Category.getSummaryTotals(categories, categoryGroups, selectedDates);
			// console.log('the groups', group);
			groupCategories.forEach((category) => {
				const budget = category.getMultiBudget(selectedDates);
				const spent = budget.getSpent();
				if(spent === 0) {
					return;
				}
				foundData = true;
				graphData.labels.push(` ${category.name}`);
				dataset.data.push(spent);
				categoriesToDisplay.push(category);
				categoriesByIndex[currentIndex] = {
					category,
					budget,
					spent,
				};
				categoryIndexes.set(category, currentIndex);

				dataset.backgroundColor.push(category.getColorRgba('.7'));
				dataset.borderColors.push(category.getColorRgba('1'));
				dataset.hoverBackgroundColor.push(category.getColorRgba('1'));
				currentIndex++;
			});
		});
		return { categoriesToDisplay, foundData, graphData, categoriesByIndex, categoryIndexes };
	}, [categories, selectedDates]);

	const graphOptions = useMemo(() => {
		return ({
			legend: {
				display: false,
			},
			onClick: (event, element) => {
				const { category } = getCategoryFromChartElement(element);
				if(!category) {
					return;
				}
				console.log('clicked category!', category);

			},
			hover: {
				onHover: (event, element) => {
					const categoryData = getCategoryFromChartElement(element);
				}
			},
			tooltips: {
				callbacks: {
					label: (tooltipItem, data) => {
						const { spent } = getCategoryFromChartElement(tooltipItem);
						const label = data.labels[tooltipItem.index];

						return `${label} - ${moneyFormatFromCents(spent)}`;
					},
					afterLabel: (tooltipItem, data) => {
						const { category, budget, spent } = getCategoryFromChartElement(tooltipItem);
						const transactions = budget.getTransactions();
						console.log(spent, category, transactions, budget);

						return `${transactions.length} Transaction${transactions.length === 1 ? '' : 's'}`;
					}
				},
			}
		});

		function getCategoryFromChartElement(chartElementInitialData) {
			const returnData = {
				category: null,
				budget: null,
				spent: null,
			};
			if(!chartElementInitialData) {
				return returnData;
			}
			if(chartElementInitialData.index !== null) {
				return retrieveChartDataByIndex(chartElementInitialData.index);
			}
			const [chartElement] = chartElementInitialData;
			if(!chartElement) {
				return returnData;
			}
			return retrieveChartDataByIndex(chartElement._index);

			function retrieveChartDataByIndex(index) {
				const categoryData = categoriesByIndex[index];
				if(!categoryData) {
					return returnData;
				}
				return categoryData;
			}
		}
	}, [categories, categoriesByIndex, selectedDates]);

	if(!foundData) {
		return (
			<NoResults>No Transactions For The Selected Period</NoResults>
		);
	}
	return (
		<div>
			<Chart
				type='doughnut'
				data={graphData}
				options={graphOptions}
				highlightIndex={highlightedCategoryIndex}
			/>
			<div>
				<SummaryCategoryItems
					categories={categoriesToDisplay}
					selectedDates={selectedDates}
					amountDisplayed={(budget) => budget.getSpent()}
					categoryMouseEnter={categoryMouseEnter}
					categoryMouseLeave={categoryMouseLeave}
				/>
			</div>
		</div>
	);

}